import * as firebase from 'firebase';
import firebaseConfig from './config/firebaseConfig'


var app = firebase.initializeApp(firebaseConfig);


firebase.analytics();


 export default app;